import { IdComponente, TIdComponente } from '../IdComponente';
import { ICampoIndiceProps } from './ICampoIndiceProps';
import { CampoTexto } from './CampoTexto';
import { CampoRadio } from './CampoRadio';
import { CampoSelect } from './CampoSelect';
import { CampoCheckbox } from './CampoCheckbox';
import { CampoData } from './CampoData';
import { CampoPeriodo } from './CampoPeriodo';
import { CampoNumerico } from './CampoNumerico';
import { CampoIntervaloNumerico } from './CampoIntervaloNumerico';
import { CampoIntervaloAlfabetico } from './CampoIntervaloAlfabetico';

export * from './ICampoIndiceProps';

export const registroDeCampos: Record<TIdComponente, React.FC<ICampoIndiceProps>> = {
    [IdComponente.TEXTO]: CampoTexto,
    [IdComponente.RADIO]: CampoRadio,
    [IdComponente.SELECT]: CampoSelect,
    [IdComponente.CHECKBOX]: CampoCheckbox,
    [IdComponente.DATA]: CampoData,
    [IdComponente.PERIODO]: CampoPeriodo,
    [IdComponente.NUMERICO]: CampoNumerico,
    [IdComponente.INTERVALO_NUMERICO]: CampoIntervaloNumerico,
    [IdComponente.INTERVALO_ALFABETICO]: CampoIntervaloAlfabetico,
    [IdComponente.CPF]: CampoTexto,
    [IdComponente.CNPJ]: CampoTexto,
};
